import { Typography, RightArrowIcon, ViewMoreButton } from 'components/UI'

// Same as HubsSection, YourTeams, LatestWork
// const PullRequestItem = () => (
// 	<li class='flex items-center space-x-2'>
// 		<BranchIcon className='text-product' />
// 		<Link href='/'>
// 			<Typography
// 				class='hover:underline'
// 				color='text-black-100'
// 				text='#89 feat: install nats js'
// 				variant='text3'
// 			/>
// 		</Link>
// 	</li>
// )

type Props = {
	openModal: (title: string, description: string) => void
}

const PullRequestsSection = ({ openModal }: Props) => (
	<div class='rounded-md border border-black-800 bg-black-850 p-5'>
		<Typography
			color='text-black-100'
			text='Pull Requests'
			variant='h5'
			weight='font-bold'
		/>
		<Typography
			class='mb-6 mt-2'
			color='text-black-200'
			text='View and manage all code changes submitted by your team. Easily review, approve, or request modifications before merging into the main codebase.'
			variant='text3'
		/>

		{/* <ul class='mt-5 space-y-2'>
			<PullRequestItem />
		</ul> */}

		<div class='mt-4 flex justify-end'>
			<ViewMoreButton
				icon={
					<RightArrowIcon className='text-black-200 group-hover:text-product' />
				}
				onClick={() =>
					openModal(
						'Pull Request',
						'View and manage all code changes submitted by your team. Easily review, approve, or request modifications before merging them into your main codebase. Stay tuned—this feature will be available soon!'
					)
				}
				text='Coming Soon'
			/>
		</div>
	</div>
)

export { PullRequestsSection }
